/**
 * Query-key roots one section invalidates in another's cache.
 *
 * A section may not import another section's keys, yet a page write that
 * changes what the ARC shows must clear the ARC's cache (custom-pages P24).
 * The root lives here and the ARC builds its own keys on it, so the prefix
 * the other section clears cannot drift from the keys the ARC reads.
 */

/** Every ARC query of one organization: the draft, its version, the picker. */
export const arcRoot = (organizationId: string | null) =>
  ['arc', organizationId] as const;
